<h1>{{'Users'|translate}}</h1>
<span *ngxPermissionsOnly="['can_create_users']">
  <paper-fab  mat-raised-button icon="add" class="action" color="accent" routerLink="/manage-users/new-user"></paper-fab>
</span>
<!-- user1 is not stored in the users DB and the profile route is closed to it
     (`non_user1_user`), so it has no other page on which to reach its RESPECT
     link. Shown to user1 only; every other user has a profile page.
     Deliberately not a mat-form-field: Material 15 defaults every field to the
     'fill' appearance, which adds inner padding, darkens the background on
     hover/focus and highlights in the primary blue. Tangerine's text fields are
     underline-only with an orange highlight, so this follows that instead (see
     the styles in this component's stylesheet). -->
<ng-container *ngxPermissionsExcept="['non_user1_user']">
  <div *ngIf="respectUrl" class="respect-link-block">
    <label class="respect-link-label" for="respect-link-input">{{'RESPECT Link'|translate}} ({{username}})</label>
    <div class="respect-link-row">
      <input id="respect-link-input" class="respect-link-input" readonly [value]="respectUrl" />
      <button mat-icon-button (click)="copyRespectUrl()" title="{{'Copy RESPECT link'|translate}}">
        <i class="material-icons mat-24 tangy-location-list-icon">content_copy</i>
      </button>
    </div>
  </div>
</ng-container>
<h2>{{'Active Users'|translate}}</h2>
<mat-table [dataSource]="activeUsers" class="mat-elevation-z8">
  <ng-container matColumnDef="username">
    <mat-header-cell *matHeaderCellDef> {{'Username'|translate}} </mat-header-cell>
    <mat-cell *matCellDef="let user">
      <span class="tangy-foreground-secondary">{{user.username}}</span>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="email">
    <mat-header-cell *matHeaderCellDef> {{'Email'|translate}} </mat-header-cell>
    <mat-cell *matCellDef="let user"> {{user.email}} </mat-cell>
  </ng-container>
  <ng-container matColumnDef="publicAccessUrl">
    <mat-header-cell *matHeaderCellDef> {{'RESPECT Link'|translate}} </mat-header-cell>
    <mat-cell *matCellDef="let user">
      <a *ngIf="user.respectToken"
        class="tangy-foreground-primary"
        [href]="getRespectUrl(user)"
        target="_blank"
        rel="noopener"
        title="{{'Open RESPECT Link'|translate}}">
        <i class="material-icons mat-24 tangy-location-list-icon">open_in_new</i>
      </a>
      <span *ngIf="!user.respectToken" class="tangy-foreground-secondary">—</span>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef> {{'Actions'|translate}} </mat-header-cell>
    <mat-cell *matCellDef="let user" >
      <a
        class="tangy-foreground-primary"
        *ngxPermissionsOnly="['can_manage_users_site_wide_permissions']"
        [routerLink]="['/manage-users/sitewide-permissions',  user.username]"
        title="{{'Security'|translate}}"
      >
        <i class="material-icons mat-24 tangy-location-list-icon">security</i>
      </a>
      <a
        class="tangy-foreground-primary"
        *ngxPermissionsOnly="['can_edit_users']"
        [routerLink]="['/manage-users/users/edit/',  user.username]"
        title="{{'Edit'|translate}}"
      >
        <i class="material-icons mat-24 tangy-location-list-icon">edit</i>
      </a>
      <span
        class="tangy-foreground-primary"
        *ngxPermissionsOnly="['can_edit_users']"
        (click)="deleteUser(user.username)"
        title="{{'Delete'|translate}}"
      >
        <i class="material-icons mat-24 tangy-location-list-icon">delete</i>
      </span>
    </mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="usersDisplayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: usersDisplayedColumns;"></mat-row>
</mat-table>
<h2>{{'Archived Users'|translate}}</h2>
<mat-table [dataSource]="archivedUsers" class="mat-elevation-z8">
  <ng-container matColumnDef="username">
    <mat-header-cell *matHeaderCellDef> {{'Username'|translate}} </mat-header-cell>
    <mat-cell *matCellDef="let user"> <span class="tangy-foreground-secondary">{{user.username}}</span> </mat-cell>
  </ng-container>
  <ng-container matColumnDef="email">
    <mat-header-cell *matHeaderCellDef> {{'Email'|translate}} </mat-header-cell>
    <mat-cell *matCellDef="let user"> {{user.email}} </mat-cell>
  </ng-container>
  <ng-container matColumnDef="publicAccessUrl">
    <mat-header-cell *matHeaderCellDef> {{'RESPECT Link'|translate}} </mat-header-cell>
    <mat-cell *matCellDef="let user">
      <a *ngIf="user.respectToken"
        class="tangy-foreground-primary"
        [href]="getRespectUrl(user)"
        target="_blank"
        rel="noopener"
        title="{{'Open RESPECT Link'|translate}}">
        <i class="material-icons mat-24 tangy-location-list-icon">open_in_new</i>
      </a>
      <span *ngIf="!user.respectToken" class="tangy-foreground-secondary">—</span>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef> {{'Actions'|translate}} </mat-header-cell>
    <mat-cell *matCellDef="let user">
      <a class="tangy-foreground-primary" [routerLink]="['/manage-users/users/edit/',  user.username]">
        <i class="material-icons mat-18 tangy-location-list-icon">edit</i>
      </a>
      <span class="tangy-foreground-primary" (click)="restoreUser(user.username)">
        <i class="material-icons mat-18 tangy-location-list-icon">restore_from_trash</i>
      </span>
    </mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="usersDisplayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: usersDisplayedColumns;"></mat-row>
</mat-table>